<script lang="ts">
const switchCls = cva("toggle border-[1.5px]", {
	variants: {
		color: {
			default: null,
			neutral: "toggle-neutral",
			primary: "toggle-primary",
			secondary: "toggle-secondary",
			accent: "toggle-accent",
			info: "toggle-info",
			success: "toggle-success",
			warning: "toggle-warning",
			error: "toggle-error",
		},
		size: {
			xs: "toggle-xs",
			sm: "toggle-sm",
			md: "toggle-md",
			lg: "toggle-lg",
		},
	},
	defaultVariants: {
		color: "default",
		size: "md",
	},
});

type _props = VariantProps<typeof switchCls>;

export interface SwitchProps extends ClassProps, DeprecatedSizeProps, SwitchRootProps {
	color?: _props["color"];
	size?: _props["size"];
}

export interface SwitchEmits extends SwitchRootEmits {}
</script>

<script setup lang="ts">
import { cva, type VariantProps } from "class-variance-authority";
import {
	SwitchRoot,
	useForwardPropsEmits,
	type SwitchRootEmits,
	type SwitchRootProps,
} from "reka-ui";
import { computed } from "vue";
import { useDelegatedProps, type ClassProps } from "../../lib/base-props";
import type { DeprecatedSizeProps } from "../../lib/size";
import { cn } from "../../lib/utils";

defineOptions({ inheritAttrs: false });

const props = defineProps<SwitchProps>();
const emit = defineEmits<SwitchEmits>();

const delegated = useDelegatedProps(props);

const forwarded = useForwardPropsEmits(delegated, emit);

const size = computed(() => {
	if (props.size != null) {
		return props.size;
	}
});
</script>

<template>
	<SwitchRoot :class="cn(switchCls({ ...props, size }), props.class)" v-bind="forwarded" />
</template>
